import { render, staticRenderFns } from "./CopyBillingListItems.yaml?vue&type=template&id=0905c8c8&component"
import script from "./CopyBillingListItems.yaml?vue&type=script&lang=ts&component"
export * from "./CopyBillingListItems.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports